import { MaterialInput } from 'app/components';
import { Container, IAppState } from 'app/containers/Container'
import { UserActions } from 'app/redux/User/actions'
import * as React from 'react'
import { Alert, Button, Col, FormGroup, Panel, Row } from 'react-bootstrap'

class Registration extends React.Component<{}, {}> {
  state = {
    firstname: '',
    lastname: '',
    email: '',
    username: '',
    password: '',
    error: null,
  }

  register(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault()
    UserActions.register(this.state.username, this.state.password, this.state.firstname, this.state.lastname, this.state.email)
      .then(() => {
        location.hash = '#/login'
      }, (error) => {
        this.setState({ error })
      })
  }

  setPartialState(attr: string, value: any) {
    const updateState = {}
    updateState[attr] = value

    this.state.error = null

    this.setState(updateState)
  }

  render() {
    return (
      <section>
        <section className="container padding-top-lg">
          <Row>
            <Col mdOffset={3} md={6}>
              <ul>
                <li>
                  To register, fill in the fields below.
              </li>
                <li>
                  After submitting your registration, you will get a comfirmation email sent to the email below.
                </li>
              </ul>
              <Panel className="animated fadeIn">
                <form name="registrationFrom" onSubmit={(e) => this.register(e)}>
                  <FormGroup>
                    <MaterialInput placeholder="Username"
                      required={true}
                      onChange={(value) => this.setPartialState('username', value)}
                      value={this.state.username} />
                  </FormGroup>
                  <FormGroup>
                    <MaterialInput placeholder="Password (must be at least 6 characters longs)"
                      required={true}
                      type="password"
                      onChange={(value) => this.setPartialState('password', value)}
                      value={this.state.password} />
                  </FormGroup>
                  <FormGroup>
                    <MaterialInput placeholder="First Name"
                      required={true}
                      onChange={(value) => this.setPartialState('firstname', value)}
                      value={this.state.firstname} />
                  </FormGroup>
                  <FormGroup>
                    <MaterialInput placeholder="Last Name"
                      required={true}
                      onChange={(value) => this.setPartialState('lastname', value)}
                      value={this.state.lastname} />
                  </FormGroup>
                  <FormGroup>
                    <MaterialInput placeholder="Email"
                      required={true}
                      onChange={(value) => this.setPartialState('email', value)}
                      value={this.state.email} />
                  </FormGroup>
                  <FormGroup>
                    <Button type="submit" bsStyle="success">
                      Register
                    </Button>
                  </FormGroup>

                  {this.state.error ?
                    <FormGroup>
                      <Alert bsStyle="danger" className="animated fadeIn">
                        <strong>
                          <i className="fa fa-fw fa-exclamation-circle" />
                          Uh oh! {this.state.error.message}
                        </strong>
                        <span>
                        </span>
                      </Alert>
                    </FormGroup>
                    : null
                  }
                </form>
              </Panel>
            </Col>
          </Row>
        </section>
      </section>
    )
  }
}

export {
  Registration
}



// WEBPACK FOOTER //
// ./src/app/containers/Registration/index.tsx